export default __webpack_public_path__ + "static/media/Frame1.b715187e.png";